import React from 'react'
import { useNavigate } from "react-router-dom";
import './Header.css';

function Header() {
  const navigate = useNavigate();
    const logout=()=>{
      sessionStorage.removeItem("access_token");
      sessionStorage.removeItem("user_id");
      sessionStorage.removeItem("email_id")
      sessionStorage.removeItem("mobile_no")
      sessionStorage.removeItem("first_name")
      sessionStorage.removeItem("middle_name")
      sessionStorage.removeItem("last_name")
      sessionStorage.removeItem("reference_id")
      navigate("/")
    }
  return (
    <>
 
 <nav className="navbar navbar-light bg-light">
  
  <div className="space" style={{width:'30%'}}>

  </div>
    <div className="logout" style={{display:'flex',justifyContent:'space-between',width:'70%'}}>
    <a className="navbar-brand" href="#" style={{textAlign:'center',fontSize:'1.7em',fontWeight:'bold'}}>GSTAT DEPUTATION APPLICATION PORTAL</a>
        <button className="btn btn-outline-danger my-2 my-sm-0" onClick={logout} type="submit">Logout</button>
    </div>
 
</nav>
   
    </>
  )
}

export default Header